export const STATUS_META = {
  redirigido: { label: "Redirigido a WhatsApp", cls: "bg-[#2A2410] text-[#FBBF24] border-[#F59E0B40]" },
  confirmado: { label: "Contacto confirmado", cls: "bg-[#0B2E1E] text-[#25D366] border-[#10B98140]" },
  convertido: { label: "Convertido", cls: "bg-[#142E1B] text-[#4ADE80] border-[#22C55E40]" },
  sin_respuesta: { label: "Sin respuesta", cls: "bg-[#2A181A] text-[#F87171] border-[#EF444440]" },
  // Compatibilidad con registros antiguos
  nuevo: { label: "Redirigido a WhatsApp", cls: "bg-[#2A2410] text-[#FBBF24] border-[#F59E0B40]" },
  contactado: { label: "Contacto confirmado", cls: "bg-[#0B2E1E] text-[#25D366] border-[#10B98140]" },
};

export const STATUS_LIST = ["redirigido", "confirmado", "convertido", "sin_respuesta"];

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.redirigido;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${m.cls}`}>
      {m.label}
    </span>
  );
}
